export const IncomeNetWorthContent = {
  header: `Next, provide your income and liquid net worth`,
};
